export default __webpack_public_path__ + "static/media/client-background.0903515e67ecf38504404172800b21ee.svg";